import React, { useState } from "react";

import { Lightbox } from "react-modal-image";

// Endereço da miniatura gerada pelo servidor. A conversa mostra ela; o arquivo
// inteiro — que num celular moderno passa de 4 MB — só é baixado quando alguém
// clica para ampliar. Sem isso, abrir um atendimento com trinta fotos gastava
// mais de 100 MB de rede para desenhar quadradinhos de 250 px.
export const miniaturaDe = (url) =>
	url ? url.replace("/public/", "/miniatura/") : url;

const ModalImageCors = ({ imageUrl }) => {
	const [aberta, setAberta] = useState(false);
	const [erro, setErro] = useState(false);
	const [carregada, setCarregada] = useState(false);

	if (!imageUrl) return null;

	if (erro) {
		return (
			<div className="flex h-[200px] w-[250px] items-center justify-center rounded-lg bg-muted text-xs text-muted-foreground">
				Não foi possível carregar a imagem
			</div>
		);
	}

	return (
		<>
			<div className="relative">
				{/* Enquanto o arquivo não chega, um retângulo do tamanho final.
				    Sem ele a conversa "pula" a cada imagem que termina de
				    carregar e a leitura se perde. */}
				{!carregada && (
					<div className="absolute inset-0 animate-pulse rounded-lg bg-muted" />
				)}
				<img
					src={miniaturaDe(imageUrl)}
					alt="Imagem enviada na conversa"
					// A imagem só é buscada quando chega perto da tela: numa
					// conversa antiga, com centenas de fotos, o navegador
					// baixava todas de uma vez ao abrir.
					loading="lazy"
					decoding="async"
					onLoad={() => setCarregada(true)}
					onError={() => setErro(true)}
					onClick={() => setAberta(true)}
					className="max-h-[400px] max-w-[280px] cursor-pointer rounded-lg object-contain"
				/>
			</div>
			{aberta && (
				<Lightbox
					medium={imageUrl}
					large={imageUrl}
					alt="Imagem enviada na conversa"
					onClose={() => setAberta(false)}
					imageBackgroundColor="transparent"
				/>
			)}
		</>
	);
};

export default ModalImageCors;
